
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  section: 'Bank Transfers',
  title: 'Webhooks',
  toc: true,
  layout: 'guide',
  description: 'Learn how to use webhooks in Bank Transfers to receive notifications when new events are available',
  noIndex: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Webhooks in Bank Transfers' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "enabling-bank-transfers-webhooks"
    }}>{`Enabling Bank Transfers webhooks`}</h4>
    <p>{`An `}<a parentName="p" {...{
        "href": "/docs/api/webhooks/"
      }}>{`overview of webhooks at Plaid`}</a>{` is available in the API Reference. There you can find general information on Plaid webhooks, including IP addresses, webhook verification, and retry logic.`}</p>
    <p>{`To enable Bank Transfers webhooks, add your endpoint on the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/webhooks"
      }}>{`account webhooks`}</a>{` page of the dashboard. If you are not able to access the page, contact your Plaid account manager.`}</p>
    <h4 {...{
      "id": "webhook-body"
    }}>{`Webhook body`}</h4>
    <p>{`To confirm that your endpoint has been correctly configured, you can trigger a test webhook via `}<inlineCode parentName="p">{`/sandbox/bank_transfer/fire_webhook`}</inlineCode>{`. You should receive the payload body specified below.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json",
        "metastring": "#Bank Transfers webhook body",
        "#Bank": true,
        "Transfers": true,
        "webhook": true,
        "body": true
      }}>{`{
  "webhook_type": "BANK_TRANSFERS",
  "webhook_code": "BANK_TRANSFERS_EVENTS_UPDATE",
  "environment": "production"
}
`}</code></pre>
    <h4 {...{
      "id": "example-integration"
    }}>{`Example integration`}</h4>
    <p>{`Upon receiving a `}<inlineCode parentName="p">{`BANK_TRANSFERS_EVENTS_UPDATE`}</inlineCode>{` webhook, poll the `}<a parentName="p" {...{
        "href": "/docs/bank-transfers/reference/#bank_transfereventsync"
      }}>{`events sync endpoint`}</a>{` to process the available events. Note that there may only be one new event, or there may be many new events.
Plaid will send a maximum of approximately 1 webhook per minute as new events continue to become available, unless you are using Bank Transfer webhooks for micro-deposit event notifications, in which case you will receive a separate webhook for each event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "switcher=false #webhookServer.js",
        "switcher": "false",
        "#webhookServer.js": true
      }}>{`// Webhook received
wait_for_and_ack_webhook();
// Fetch the maximum event ID from your systems
after_id = fetch_last_event_id();
var events = [];

// Poll event sync endpoint for all new events
do {
  // Fetch the next set of events and update after_id
  events = await plaidClient.bankTransferEventSync(after_id);
  after_id += events.length;

  // Handle new events
  for (event of events) {
    yourEventHandler(event);
  }
} while (events.length > 0);
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "enabling-bank-transfers-webhooks",
        level: 4,
        title: "Enabling Bank Transfers webhooks",
      },
{
        id: "webhook-body",
        level: 4,
        title: "Webhook body",
      },
{
        id: "example-integration",
        level: 4,
        title: "Example integration",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
